import * as Sentry from '@sentry/react';
import {isCancelledError} from '@tanstack/react-query';
import {isAbortError} from '~/library/network-facade';

let report: (err: Error) => void;
if (import.meta.env.PROD) {
    report = Sentry.captureException;
} else {
    report = error => console.info('%cWill report:', 'color:orange;', error);
}

export const translateAndSendError = (error: unknown) => {
    if (isAbortError(error)) {
        return;
    }
    if (error instanceof Error) {
        return report(error);
    } //
    if (isCancelledError(error)) {
        report(new Error('Unhandled CancelledError'));
    } //
    else if (typeof error !== 'boolean' && !error) {
        report(new Error(`Nullish error captured`, {cause: error}));
    } //
    else if (typeof error !== 'object') {
        report(new Error(`Non object error captured`, {cause: error}));
    } //
    else if ('stack' in error && 'message' in error && typeof error.message === 'string') {
        report(Object.assign(new Error(error.message), error));
    } //
    else {
        report(new Error(`Strange error captured: ${JSON.stringify(error)}`));
    }
};
